import { Flex, Token, VStack } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { Markdown } from 'components'
import { Message } from 'lib/apiClient'

import { usePrompt } from '../../../providers/PromptProvider'
import { CollapsibleMessageText } from './CollapsibleMessageText'
import { FixedPromptTextGeneration } from './FixedPromptTextGeneration'

type Props = Message

export const StackMessageDebug: FC<Props> = props => {
  const { text } = props

  const { fixedPromptTextGenerationsCount } = usePrompt()

  return (
    <Flex justifyContent="flex-end" data-testid="stack-message-debug">
      <VStack
        space="s-4"
        maxWidth="calc(100% - 64px)"
        bg="background"
        borderRadius="24px"
        p="s-2"
        border={`2px ${Token.color.lightBlue} dashed`}
      >
        <CollapsibleMessageText
          label="Original"
          variant="grey"
          collapsible={Boolean(fixedPromptTextGenerationsCount)}
        >
          <Markdown chatUiRenderMethod>{text}</Markdown>
        </CollapsibleMessageText>
        <FixedPromptTextGeneration />
      </VStack>
    </Flex>
  )
}
